import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminSubscriptionsBulkPriceChangeDetailsResponse {
  @jsonMember(Boolean)
  public readonly isBulkPriceChangeAvailable!: boolean;
}
